import type { SVGProps } from 'react';

const SvgNavigationAi = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M7 0c.302 0 .577.175.705.449l.88 1.886a6.37 6.37 0 0 0 3.08 3.08l1.886.88a.778.778 0 0 1 0 1.41l-1.886.88a6.37 6.37 0 0 0-3.08 3.08l-.88 1.886a.778.778 0 0 1-1.41 0l-.88-1.886a6.37 6.37 0 0 0-3.08-3.08l-1.886-.88a.778.778 0 0 1 0-1.41l1.886-.88a6.37 6.37 0 0 0 3.08-3.08l.88-1.886A.78.78 0 0 1 7 0m0 2.617-.175.376a7.93 7.93 0 0 1-3.832 3.832L2.617 7l.376.175a7.93 7.93 0 0 1 3.832 3.833l.175.375.175-.375a7.93 7.93 0 0 1 3.833-3.833L11.383 7l-.375-.175a7.93 7.93 0 0 1-3.833-3.832z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgNavigationAi;
